<template>
  <EditHikeDetailsModal ref="modal" :hike="hike" @save="saveHikeDetails" />
</template>

<script setup>
// Standalone mount of the hikes-list "Edit Details" modal for the (server-rendered)
// hike overview page. Reuses the same EditHikeDetailsModal + UpdateHikeDetails
// mutation; on success it reloads so the page reflects the new name/description/
// difficulty/visibility.
import { ref, onMounted } from 'vue'
import EditHikeDetailsModal from '../hikes/components/EditHikeDetailsModal.vue'
import graph_client from '../../utils/graphql/graph_client'
import { UpdateHikeDetails } from '../../utils/graphql/hikes-graph'
import { i18n } from '../../i18n'

const hike = ref(window.editHikeDetailsData || null)
const modal = ref(null)

onMounted(() => {
  // Exposed so the ERB "Edit Details" menu item can open the modal.
  window.openEditHikeDetails = () => modal.value?.show()
})

async function saveHikeDetails (formData, { done, fail }) {
  const current = hike.value
  if (!current?.id) return fail(i18n.global.t('edit_hike_details.no_hike_selected'))

  try {
    const result = await graph_client.request(UpdateHikeDetails, {
      input: {
        id: current.id,
        name: formData.name,
        description: formData.description,
        difficulty: formData.difficulty,
        publiclyVisible: formData.publiclyVisible
      }
    })

    const errors = result?.updateHikeDetails?.errors
    if (errors && errors.length > 0) {
      return fail(errors.map(e => e.errors.join(', ')).join('; '))
    }

    done()
    window.location.reload()
  } catch (err) {
    console.error('UpdateHikeDetails failed:', err)
    const msg = err?.response?.errors?.[0]?.message || err?.message || i18n.global.t('edit_hike_details.failed_to_update_hike_details')
    fail(msg)
  }
}
</script>
